import * as React from 'react';

const Percent24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.517 16.788h.005-.01zm.68-.41a.76.76 0 0 1-.68.41.9.9 0 0 1-.354-.082.767.767 0 0 1-.327-1.036l4.002-7.725a.766.766 0 1 1 1.362.708zm-1.482-6.176a1.025 1.025 0 1 1-1.023-1.026c.565 0 1.023.46 1.023 1.026m6.764 4.955a1.025 1.025 0 1 0-.002-2.054 1.025 1.025 0 0 0 .002 2.054"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.864 21.6c.5.266 1.05.4 1.602.4H7.46h.01-.005c.367 0 .743-.062 1.1-.185l8.834-2.944a3.62 3.62 0 0 0 2.119-1.867l3.08-6.258c.912-1.847.216-4.124-1.555-5.078l-6.04-3.252a3.48 3.48 0 0 0-2.753-.236L3.52 5.093c-1.894.626-2.948 2.75-2.355 4.72l2.867 9.54c.296.985.941 1.785 1.832 2.247m6.878-17.963c.195-.072.41-.103.614-.103v.01c.318 0 .635.082.932.236l6.04 3.252c1.053.554 1.463 1.929.91 3.037l-3.08 6.258a2.08 2.08 0 0 1-1.219 1.087L8.105 20.36a1.97 1.97 0 0 1-1.525-.124 2.15 2.15 0 0 1-1.074-1.323L2.65 9.372c-.36-1.191.256-2.452 1.36-2.822l8.731-2.913Z"
  }
));
Percent24.Size = 24;
Percent24.Title = "Percent";

export { Percent24 as default };
